import category from 'components/forms/category/content'
import emergencyContact from 'components/forms/emergencyContact/content'
import participant from 'components/forms/participant/content'
import tandem from 'components/forms/tandem/content'

const content = ({
  // for category form
  values,
  categories,
  onCategoryChange,
  currentRelayEvent,
  selectedRelayEvent,
  onRelayEventChange,
  fullShirtDetails,
  hasJersey,
  hasBibName,
  subCategories,

  // for tandem form
  tandemInfo,

  // common
  formDisabled,
  updateField,
}) => [
  {
    id: 'update-category-form',
    name: 'Event',
    inputs: category({
      values,
      categories,
      onCategoryChange,
      currentRelayEvent,
      selectedRelayEvent,
      onRelayEventChange,
      fullShirtDetails,
      hasJersey,
      hasBibName,
      subCategories,
      formDisabled,
    }),
  },
  {
    id: 'update-participant-form',
    name: 'Participant',
    inputs: participant({ formDisabled, updateField }),
  },
  { ...(tandemInfo.isTandem && tandem({ formDisabled, updateField })) },
  {
    id: 'update-emergencyContact-form',
    name: 'Emergency Contact',
    inputs: emergencyContact({ formDisabled, isOnsiteRegistration: true }),
  },
]

export default content
